import * as React from "react";
import BaseUnsupportedIssuerRoute from "../../features/auth/routes/unsupported-issuer";
import useAppSelector from "../../hooks/useAppSelector";
export default function HomeUnsupportedIssuerRoute() {
    var issuer = useAppSelector(function (state) { return state.applicant.currentIssuer.home; });
    return React.createElement(BaseUnsupportedIssuerRoute, { issuer: issuer });
}
